/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeavePolicy
 */
export interface LeavePolicy {
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    defaultLeaveTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof LeavePolicy
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LeavePolicy
     */
    startDateType: LeavePolicyStartDateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    startDay: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    startMonth: number | null;
    /**
     * 
     * @type {string}
     * @memberof LeavePolicy
     */
    interval: LeavePolicyIntervalEnum;
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    maxFuturePeriods: number;
    /**
     * 
     * @type {number}
     * @memberof LeavePolicy
     */
    leaveNoticePeriodInDays: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeavePolicy
     */
    leaveAllowanceCanBeExceeded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeavePolicy
     */
    excludePublicHolidaysFromWorkingTimeLost: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof LeavePolicy
     */
    leaveTypeIds: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum LeavePolicyStartDateTypeEnum {
    EmployeeJoinDate = 'Employee Join Date',
    SpecificDate = 'Specific Date'
}
/**
* @export
* @enum {string}
*/
export enum LeavePolicyIntervalEnum {
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    Yearly = 'Yearly'
}


/**
 * Check if a given object implements the LeavePolicy interface.
 */
export function instanceOfLeavePolicy(value: object): value is LeavePolicy {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('defaultLeaveTypeId' in value) || value['defaultLeaveTypeId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startDateType' in value) || value['startDateType'] === undefined) return false;
    if (!('startDay' in value) || value['startDay'] === undefined) return false;
    if (!('startMonth' in value) || value['startMonth'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('maxFuturePeriods' in value) || value['maxFuturePeriods'] === undefined) return false;
    if (!('leaveNoticePeriodInDays' in value) || value['leaveNoticePeriodInDays'] === undefined) return false;
    if (!('leaveAllowanceCanBeExceeded' in value) || value['leaveAllowanceCanBeExceeded'] === undefined) return false;
    if (!('excludePublicHolidaysFromWorkingTimeLost' in value) || value['excludePublicHolidaysFromWorkingTimeLost'] === undefined) return false;
    if (!('leaveTypeIds' in value) || value['leaveTypeIds'] === undefined) return false;
    return true;
}

export function LeavePolicyFromJSON(json: any): LeavePolicy {
    return LeavePolicyFromJSONTyped(json, false);
}

export function LeavePolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeavePolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'defaultLeaveTypeId': json['defaultLeaveTypeId'],
        'name': json['name'],
        'startDateType': json['startDateType'],
        'startDay': json['startDay'],
        'startMonth': json['startMonth'],
        'interval': json['interval'],
        'maxFuturePeriods': json['maxFuturePeriods'],
        'leaveNoticePeriodInDays': json['leaveNoticePeriodInDays'],
        'leaveAllowanceCanBeExceeded': json['leaveAllowanceCanBeExceeded'],
        'excludePublicHolidaysFromWorkingTimeLost': json['excludePublicHolidaysFromWorkingTimeLost'],
        'leaveTypeIds': json['leaveTypeIds'],
    };
}

  export function LeavePolicyToJSON(json: any): LeavePolicy {
      return LeavePolicyToJSONTyped(json, false);
  }

  export function LeavePolicyToJSONTyped(value?: LeavePolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'defaultLeaveTypeId': value['defaultLeaveTypeId'],
        'name': value['name'],
        'startDateType': value['startDateType'],
        'startDay': value['startDay'],
        'startMonth': value['startMonth'],
        'interval': value['interval'],
        'maxFuturePeriods': value['maxFuturePeriods'],
        'leaveNoticePeriodInDays': value['leaveNoticePeriodInDays'],
        'leaveAllowanceCanBeExceeded': value['leaveAllowanceCanBeExceeded'],
        'excludePublicHolidaysFromWorkingTimeLost': value['excludePublicHolidaysFromWorkingTimeLost'],
        'leaveTypeIds': value['leaveTypeIds'],
    };
}

